import {
  ReversePrintingLayoutsAction,
  UPDATE_LAYOUTS_STATE,
} from 'cards/actions/reversePrintingLayouts';
import type { WCardTemplateLayoutContentView } from '@zola/svc-web-api-ts-client';

export enum LAYOUTS {
  graphicDesign = 'GRAPHIC_DESIGN',
  image = 'IMAGE',
  noPrint = 'NO_PRINT',
  text = 'TEXT',
}

// Use our local enum for layout content and assert that uuid is defined
export type Layout = WCardTemplateLayoutContentView & {
  content: LAYOUTS[];
  uuid: string;
};

export interface ReversePrintingLayoutsState {
  layouts: Layout[];
  loading: boolean;
  uuid: string | null;
}

const initialState: ReversePrintingLayoutsState = {
  layouts: [],
  loading: false,
  uuid: null,
};

const reversePrintingLayoutsReducer = (
  state = initialState,
  action: ReversePrintingLayoutsAction
): ReversePrintingLayoutsState => {
  switch (action.type) {
    case UPDATE_LAYOUTS_STATE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

export default reversePrintingLayoutsReducer;
